/** PURE_IMPORTS_START ._NeverObservable PURE_IMPORTS_END */
import { NeverObservable } from './NeverObservable';
export var never = NeverObservable.create;
//# sourceMappingURL=never.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/never.js
// module id = ./node_modules/rxjs/_esm5/observable/never.js
// module chunks = vendor